module.exports = __webpack_public_path__ + "img/08.3544094b.png";